"use client";

import type { PanelVisuProps } from "@tosize/panel-visualisation";
import type { ProductGroup } from "@tosize/ui";
import { createContext, useContext } from "react";
import type { Workpiece } from "../lib/workpiece";
import type { PostData } from "./PostDataContext";

type Mode = "editCartItem" | "editProjectItem" | "add" | "addInDialog";

export interface ConfigContextValue {
	apiUrl: string;
	cartId?: string;
	initialPostData?: Partial<PostData>;
	initialWorkpiece?: Partial<Workpiece>;
	mode: Mode;
	productGroup: ProductGroup | null;
	groupedProduct: string;
	settings: Map<string, string>;
	routes: Map<string, string>;
	carrierCode?: string;
	postcode?: string | null;
	projects: { id: string; name: string }[];
	customer?: { id: string };
	onAddToCart: (data: PostData, workpiece: Workpiece) => Promise<void>;
	onAddToProject: (
		data: PostData,
		workpiece: Workpiece,
		name: string,
		id?: string,
	) => Promise<void>;
	onDataChange?: (data: PanelVisuProps) => unknown;
	setActiveDialog: (
		dialog?: "saveProject" | "importProducts_list" | "importProducts_file" | "postcode",
	) => void;
}

export const ConfigContext = createContext<ConfigContextValue>({} as ConfigContextValue);

export function useConfig() {
	const context = useContext(ConfigContext);

	if (context === null) throw new Error("ConfigContext of Panelconfigurator is not available");

	return context;
}
